import { jsx as y } from "react/jsx-runtime";
import { useState as P, useCallback as L, useMemo as V, useEffect as H, useLayoutEffect as S } from "react";
import { usePrevState as k } from "@perxis-auto/shared";
import { useApp as B, useConfig as F, useCurrentStage as M } from "@perxis-auto/trade-in-sdk";
import { APP_EVENTS as O, APP_EVENT_BUTTONS as b, APP_EVENTS_CHANNEL as A } from "../../../shared/config/events.js";
import { AppContext as j } from "../../../shared/lib/app/context/appContext.js";
import { withTradeInProvider as w } from "../../../shared/lib/app/hoc/withTradeInProvider.js";
import { eventService as D } from "../../../shared/lib/event/eventService.js";
function R({ apiRoot: o, clientId: n, language: u, eventsHandler: d, children: C }) {
  const {
    actions: { reset: p }
  } = B(), { actions: T } = F(), { setApiRoot: m, setClientId: a } = T, { data: t } = M(), e = k(t), [s, i] = P([]), [_, h] = P({}), { onSuccess: f, onFailure: v, onReset: c } = _, E = L(() => (p(), i([]), D.sendEvent(O.ButtonClicked, { id: b.RESET_FORM }), c == null ? void 0 : c()), [c, p]), N = V(
    () => ({
      apiRoot: o,
      clientId: n,
      language: u,
      prevStage: s.length ? s[s.length - 1] : null,
      onSuccess: f,
      onFailure: v,
      onReset: E,
      setAppHandlers: h
    }),
    [o, n, u, s, f, v, E]
  );
  H(() => {
    if (!t) {
      i([]);
      return;
    }
    if (!(!e || e.id === t.id)) {
      if (e.success === t.id || e.error === t.id || e.go_to === t.id) {
        i((r) => [...r, e]);
        return;
      }
      i((r) => r.slice(0, -1));
    }
  }, [t == null ? void 0 : t.id]);
  const l = (r) => {
    if (!d)
      return;
    const { type: g } = r.detail, x = r.detail;
    d(g, x);
  };
  return S(() => (document.addEventListener(A, l), () => {
    document.removeEventListener(A, l);
  }), []), S(() => {
    m(o), a(n);
  }, [o, n, m, a]), /* @__PURE__ */ y(j.Provider, { value: N, children: C });
}
const X = w(R);
export {
  X as AppProvider
};
